import React, {useEffect, useState} from 'react';

const Alerter = ({children, cancelText, acceptText, onAccept, onCancel}) => {
    const [isVisible, setIsVisible] = useState(true);

    const handleAccept = () => {
        if (onAccept) onAccept();
        setIsVisible(false);
    };

    const handleCancel = () => {
        if (onCancel) onCancel();
        setIsVisible(false);
    };

    useEffect(() => {
        if (!isVisible) {
            const popup = document.querySelector('.klinger-popup');
            if (popup) popup.remove();
        }
    }, [isVisible]);

    if (!isVisible) return null;

    return (
        <div className="klinger-popup">
            <div className="klinger-popup__overlay close" onClick={handleCancel}></div>
            <div className="klinger-popup__holder">
                {typeof handleCancel === "function" && typeof children === "function" ? children(handleCancel) : children}
                <div className="row">
                    {cancelText && (
                        <div className="col-auto">
                            <div className="close">
                                <button id="cancel" className="btn btn-secondary d-flex" onClick={handleCancel}>
                                    <div className="btn-arrow">
                                        <svg width="50px" height="50px" viewBox="0 0 50 50" version="1.1"
                                             xmlns="http://www.w3.org/2000/svg"
                                             xmlnsXlink="http://www.w3.org/1999/xlink">
                                            <g id="Symbols" stroke="none" strokeWidth="1" fill="none"
                                               fillRule="evenodd">
                                                <path className="inline-svg"
                                                      d="M24.5639893,19 L26.9521116,19 L30.9973338,25.1216537 L26.9493623,31.2700005 L24.5639893,31.2700005 L28.6109479,25.1239623 L24.5639893,19 Z M19,19 L21.3879776,19 L25.4334892,25.1216537 L21.3849389,31.2700005 L19,31.2700005 L23.0469586,25.1239623 L19,19 Z"
                                                      id="Fill-1"></path>
                                            </g>
                                        </svg>
                                    </div>
                                    <span>{cancelText}</span>
                                </button>
                            </div>
                        </div>
                    )}
                    {acceptText && (
                        <div className="col-auto">
                            <div className="accept">
                                <button id="accept" className="btn btn-success d-flex" onClick={handleAccept}>
                                    <div className="btn-arrow">
                                        <svg width="50px" height="50px" viewBox="0 0 50 50" version="1.1"
                                             xmlns="http://www.w3.org/2000/svg"
                                             xmlnsXlink="http://www.w3.org/1999/xlink">
                                            <g id="Symbols" stroke="none" strokeWidth="1" fill="none"
                                               fillRule="evenodd">
                                                <path className="inline-svg"
                                                      d="M24.5639893,19 L26.9521116,19 L30.9973338,25.1216537 L26.9493623,31.2700005 L24.5639893,31.2700005 L28.6109479,25.1239623 L24.5639893,19 Z M19,19 L21.3879776,19 L25.4334892,25.1216537 L21.3849389,31.2700005 L19,31.2700005 L23.0469586,25.1239623 L19,19 Z"
                                                      id="Fill-1"></path>
                                            </g>
                                        </svg>
                                    </div>
                                    <span>{acceptText}</span>
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Alerter;